<script setup lang="ts">
import View from '~/pages-components/blog/search-list.vue'
</script>

<template>
  <div>
    <View />
  </div>
</template>
